import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { FlexRow } from 'ui-components/components/flex';

import { NumberInput } from 'ui-components/components/number-input';

import { createColumnDefinitionBuilder } from '../../../../../components/items-table/create-column-definition-builder';

import messages from '../messages';
import style from '../style.module.less';

const EditItemQuantityColumnId = 'edit-quantity';
const QuantityPropertyName = 'quantity';

const editItemQuantityDataBuilder = (item) => {
  return {
    id: item.id,
    quantity: item.quantity,
    readonly: item.readonly,
  };
};

// TODO: Rather than setting a min value on the input, we should have validation that lets
// the merchant go to a non-positive integer, but inform them of the error on blur
const EditItemQuantity = ({ value: item, onColumnBlur, disabled = false }) => {
  const [quantity, setQuantity] = useState(item.quantity);

  const publishValueChange = useCallback(
    (value) => {
      onColumnBlur(item.id, {
        [QuantityPropertyName]: value,
      });
    },
    [onColumnBlur, item.id],
  );

  const onArrowButtonPress = useCallback(
    (value) => {
      publishValueChange(value);
      setQuantity(value);
    },
    [setQuantity, publishValueChange],
  );

  const onBlur = useCallback(
    (event) => {
      const parsedValue = Number.parseInt(event?.target?.value, 10);
      setQuantity(parsedValue);
      publishValueChange(parsedValue);
    },
    [setQuantity, publishValueChange],
  );

  if (item.readonly?.code) {
    return <FlexRow className={style['read-only-quantity']}>{quantity}</FlexRow>;
  }

  return (
    <NumberInput
      className={style['quantity-input']}
      disabled={disabled}
      min={1}
      onArrowButtonPress={onArrowButtonPress}
      onBlur={onBlur}
      onChange={setQuantity}
      value={quantity}
    />
  );
};

EditItemQuantity.propTypes = {
  value: PropTypes.shape({
    id: PropTypes.string.isRequired,
    quantity: PropTypes.number.isRequired,
    readonly: PropTypes.shape({
      code: PropTypes.string,
    }),
  }).isRequired,
  onColumnBlur: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

const createEditItemQuantityColumnDefinition = createColumnDefinitionBuilder({
  header: <FormattedMessage {...messages.itemQuantity} />,
  accessor: EditItemQuantityColumnId,
  className: style['right-align-header'],
  cell: EditItemQuantity,
  width: 0.5,
});

export { EditItemQuantityColumnId, editItemQuantityDataBuilder, createEditItemQuantityColumnDefinition };
